import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Card } from "../../../components/Card";
import { ResponsivePie } from "@nivo/pie";
import { translateSubElementString } from "../../../utils";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { QuestionIconTooltip } from "../../../components";

function EmissionsReductionDonutChart({ data }) {
  const { t } = useTranslation("translation");

  return (
    <Card padding={5} height="100%">
      <Flex alignItems="center">
        <Heading as="h2" size="md">
          {t("supplierAdminDashboard.targetedReduction")}
        </Heading>
        {window?.location?.hostname?.includes("howdens") && (
          <QuestionIconTooltip
            label={translateSubElementString("supplierAdminDashboard.reductionTooltip")}
            ariaLabel={"targeted-reduction-tooltip"}
            height={"unset"}
            fontSize="sm"
            iconSize={14}
            size="sm"
            placement={"bottom-start"}
          />)
        }
      </Flex>

      <Box height={"250px"}>
        {data && data?.length > 0 ?
          <ResponsivePie
            data={data}
            margin={{ top: 10, right: 10, bottom: 60, left: 10 }}
            theme={{ legends: { text: { fontSize: 16 } } }}
            colors={({ data }) => data["color"]}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            tooltip={tooltipObj => {
              const { datum: { data } } = tooltipObj;
              const formattedValue = data.actualValue && data.actualValue > 0 ?
                data.actualValue.toLocaleString("en-GB", { maximumFractionDigits: 2 }) : "";

              return (
                <Box position="relative">
                  <Card
                    position="absolute"
                    minWidth={"300px"}
                    padding={3}
                    right={"100%"}
                  >
                    <Text fontSize="sm">
                      {data.label}: <b>{formattedValue}</b> tCO<sub>2e</sub>
                    </Text>
                  </Card>
                </Box>);
            }}
            borderWidth={1}
            borderColor={{
              from: "color"
            }}
            enableArcLinkLabels={false}
            arcLabel={(el) => {
              return el.data.value && el.data.value > 0 ?
                `${el.data.value.toLocaleString("en-GB", { maximumFractionDigits: 2 })}%` : "";
            }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={"white"}
            legends={[
              {
                anchor: "bottom",
                direction: "column",
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 10,
                itemWidth: 200,
                itemHeight: 18,
                itemTextColor: "#999",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000"
                    }
                  }
                ]
              }
            ]}
          />
          : <Text fontSize="lg" fontWeight="bold" paddingTop={5}>{t("noDataAvailable")}</Text>
        }
      </Box>
    </Card>
  );
}

export default EmissionsReductionDonutChart;